"use strict";

export function initFooter() {
  $("#footer-container").load('../../components/footer.html', function () {
    //toto
  });
  console.log("fin : initBanner")
}